import request from "../request";

export class CustomerServiceService {
  static get = async () => {
    return await request.get('/customer_service');
  }
}
